<template>
  <NavBar />
  <main class="page-main">
    <router-view />
  </main>
  <AppFooter />
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import AppFooter from './components/AppFooter.vue'
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background: #ffbbe2;
  color: #f0eef6;
  font-family: 'Inter', Arial, sans-serif;
  min-height: 100vh;
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.page-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.header-nav, .nav-content, .nav-links {
  box-sizing: border-box;
}
.header-nav {
  width: 100%;
  background: #feb1dc;
  box-shadow: 0 1px 8px #e47ebc30;
  padding: 0.6rem 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.nav-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 2vw;
  padding-right: 3vw;
  box-sizing: border-box;
}
.nav-logo {
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 1px;
  color: #f8f6fb;
  font-family: 'Inter', Arial, sans-serif;
}
.nav-links {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.nav-links a,
.nav-links .router-link-active,
.nav-links .router-link-exact-active {
  color: #f8f6fb;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  margin-left: 2.2rem;
  transition: color 0.12s;
  letter-spacing: 0.5px;
  opacity: 0.95;
  display: inline-block;
  vertical-align: middle;
}
.nav-links a:first-child,
.nav-links .router-link-exact-active:first-child {
  margin-left: 0;
}
.nav-links a:hover,
.nav-links .router-link-active:hover,
.nav-links .router-link-exact-active:hover {
  color: #391a67;
  opacity: 1;
}
@media (max-width: 600px) {
  .nav-content {
    flex-direction: row;
    justify-content: space-between;
    padding-left: 2vw;
    padding-right: 2vw;
  }
  .nav-logo {
    font-size: 1.05rem;
    margin-right: 1vw;
  }
  .nav-links {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: auto;
  }
  .nav-links a,
  .nav-links .router-link-active,
  .nav-links .router-link-exact-active {
    margin-left: 0.7rem;
    font-size: 0.93rem;
    letter-spacing: 0.2px;
    word-break: normal;
    padding: 0 0.2rem;
  }
}
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 90px 20px 20px;
}
.tagline {
  font-size: 1.35rem;
  margin-bottom: 2rem;
  color: #391a67;
}
.download-btn {
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #9e4bff, #ff7fc6 90%);
  color: #fff;
  box-shadow: 0 2px 16px #a56cff60;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.12s, box-shadow 0.2s;
  margin-bottom: 2rem;
  display: inline-block;
}
.download-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 24px #a56cff80;
}
@media (max-width: 900px) {
  .tagline { font-size: 1rem; }
  .download-btn { font-size: 1rem; padding: 0.7rem 1.5rem; }
}
</style>
